import { render, staticRenderFns } from "./ContentLoad.vue?vue&type=template&id=86d2af76"
import script from "./ContentLoad.vue?vue&type=script&lang=js"
export * from "./ContentLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports